import { Component, Input, NO_ERRORS_SCHEMA } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-faqs',
  standalone: true,
  //imports: [],
  schemas: [NO_ERRORS_SCHEMA],
  templateUrl: './faqs.component.html',
  styleUrl: './faqs.component.scss'
})
export class FaqsComponent {
  [key: string]: any;
  @Input() faqList = []
  @Input() application = ""
  @Input() module = ""
  @Input() page = ""


  constructor(
    private sanitizer: DomSanitizer,
  ) {
    console.log("fffff", this.faqList)
  }


  ngOnInit() {
    // `data` should be available here
    console.log('ngOnInit: data =', this.faqList);
  }



  displayDescription(desc: any) {
    let description = this.sanitizer.bypassSecurityTrustHtml(
    this.decodeHtml(desc)
    );
    console.log("=========safe desc======", description);
    console.log("lol", Object(description).changingThisBreaksApplicationSecurity)
    return description = Object(description).changingThisBreaksApplicationSecurity;

  }

  decodeHtml(html: string): string {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = html;
    return textArea.value;
  }

}
